export default __webpack_public_path__ + "static/media/benefit-2.aea25eff.svg";